import { useTranslation } from "react-i18next";

const LoginLoading = () => {
  const { t } = useTranslation("common");

  return <div className="p-4">{t("auth.logging_in")}</div>;
};
export default LoginLoading;
